import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Loadable from "react-loadable";

import { queryString } from "../utils";
import { incrementOffset, resetOffset, fetchActivities, updateQueryString } from "../actions";
import { Loader } from "./Loader";
import ActivityCardContainer from "./ActivityContainer";
import LazyLoadImage from "./LazyLoad/LazyLoadImage";
import { AsynLoader } from "./Loader/AsynLoader";

const DISTANCE_FROM_BOTTOM = 500;
class ActivityList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      mount: false
    };
  }
  componentDidMount() {
    const { search } = this.props.location;

    let query = queryString.parse(search);

    if (this.props.match.params.countryId) {
      query.countryName = this.props.match.params.countryName;
      query.countryId = this.props.match.params.countryId;
    } else if (this.props.match.params.stateId) {
      query.stateName = this.props.match.params.stateName;
      query.stateId = this.props.match.params.stateId;
    } else if (this.props.match.params.locationId) {
      query.destination = this.props.match.params.destination;
      query.locationId = this.props.match.params.locationId;
    }
    if (this.props.match.params.type) {
      query.type = this.props.match.params.type;
    }

    if (this.props.match.params.tourType) {
      query.tourType = this.props.match.params.tourType;
    }

    this.props.updateQueryString(query);

    window.addEventListener("scroll", this.onScroll, false);
    window.addEventListener("scroll", this.onScrollStickHeader, false);
  }

  componentDidUpdate(prevProps) {
    if (this.props.query !== prevProps.query) {
      if (this.state.mount) {
        window.addEventListener("scroll", this.onScroll, false);
        //this.props.resetOffset();
        this.setState(prev => ({ offset: prev.offset * 0 }));
        this.newQueryActivities();
      } else {
        this.setState({ mount: true });
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll, false);
    window.removeEventListener("scroll", this.onScrollStickHeader, false);
  }

  onScrollStickHeader = () => {
    let filterHeader = document.getElementById("banner__container__sticky_header");
    let activityList = document.getElementById("content");
    let sticky = filterHeader.offsetTop;

    if (window.pageYOffset > sticky) {
      filterHeader.classList.add("sticky");
      activityList.style.paddingTop = `${filterHeader.offsetHeight}px`;
    } else {
      filterHeader.classList.remove("sticky");
      activityList.style.paddingTop = `0px`;
    }
  };
  onScroll = () => {
    let activityList = document.getElementById("content");
    if (
      window.innerHeight + window.scrollY >= activityList.offsetHeight - DISTANCE_FROM_BOTTOM &&
      this.props.activities.length &&
      this.props.activities.length < this.props.activityCount &&
      !this.props.loading
    ) {
      if ((this.state.offset + 1) * 12 === this.props.activities.length)
        this.setState(prev => ({ offset: prev.offset + 1 }));
      //this.props.incrementOffset();
      this.newQueryActivities(true);
    } else if (this.props.activities.length === this.props.activityCount) {
      document.removeEventListener("scroll", this.onScroll, false);
    }
  };

  newQueryActivities = (more = false) => {
    let getRequest = this.props.query;

    getRequest.offset = more ? this.state.offset : 0;

    const a = this.generate(getRequest);

    let q = queryString.stringify(a);
    this.props.fetchActivities(q, more);
  };

  generate = queryString => {
    let q = {};

    if (queryString.location.category === "Country") {
      q.countryId = queryString.location.id;
    } else if (queryString.location.category === "State") {
      q.stateId = queryString.location.id;
    } else {
      if (queryString.locationId) {
        q.locationId = queryString.locationId;
      } else if (queryString.location.id) {
        q.locationId = queryString.location.id;
      }
    }

    if (queryString.type && queryString.type !== "") {
      q.type = queryString.type;
    }

    if (queryString.sort.sort) {
      q.sort = queryString.sort.sort;
      q.order = queryString.sort.order;
    }

    if (queryString.price.to) {
      q.priceFrom = queryString.price.from;
      q.priceTo = queryString.price.to;
    }

    if (queryString.date.from) {
      q.from = queryString.date.from;
      q.to = queryString.date.to;
    }
    if (queryString.tourType) {
      q.tourType = queryString.tourType;
    }
    q.offset = queryString.offset;
    return q;
  };

  render() {
    if (this.props.pageLoader) {
      return (
        <div>
          <Loader />
        </div>
      );
    }

    const { activities } = this.props;
    return (
      <div className="t-row" id="activity-list-container" style={{ alignItems: "flex-start" }}>
        {activities.length > 0 &&
          activities.map(activity => {
            return (
              <ActivityCardContainer key={activity.activity_id}>
                <LazyLoadImage>
                  <AsynActivityCard {...activity} currency={this.props.currency} />
                </LazyLoadImage>
              </ActivityCardContainer>
            );
          })}
        {this.props.loading && <Loader />}
        {!this.props.loading &&
          this.props.activityCount === activities.length &&
          (this.props.activityCount === 0 ? <AsynZeroActivityFound /> : <AsynNoActivityLeft />)}
      </div>
    );
  }
}
const mapStateToProps = state => {
  return {
    loading: state.contentLoader,
    pageLoader: state.pageLoader,
    activities: state.activities.activities,
    activityCount: state.activities.count,
    query: state.queryString,
    currency: state.currency.current,
    offset: state.offset
  };
};

const mapDispatchToProps = dispatch => {
  return {
    incrementOffset: () => dispatch(incrementOffset),
    resetOffset: () => dispatch(resetOffset),
    fetchActivities: (queryString, more) => dispatch(fetchActivities(queryString, more)),
    updateQueryString: queryString => dispatch(updateQueryString(queryString))
  };
};

const AsynActivityCard = Loadable({
  loader: () => import("./ActivityCard"),
  render(loaded, props) {
    let Component = loaded.default;
    return <Component {...props} />;
  },
  loading: AsynLoader
});

const AsynZeroActivityFound = Loadable({
  loader: () => import("./NoActivityFound"),
  render(loaded, props) {
    let Component = loaded.NoActivityFound;
    return <Component {...props} />;
  },
  loading: AsynLoader
});
const AsynNoActivityLeft = Loadable({
  loader: () => import("./NoActivityFound"),
  render(loaded, props) {
    let Component = loaded.NoMoreActivityLeft;
    return <Component {...props} />;
  },
  loading: AsynLoader
});
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ActivityList)
);
